import { useQuery } from '@tanstack/react-query';

import { Typography } from '@/shared/ui';

import api from '@/api';
import { queryKeys } from '@/api/queryKeys';

import { ExternalServiceList } from './children/ExternalServiceList/ExternalServiceList';

import './ExternalServicesPage.scss';

export const ExternalServicesPage: React.FC = () => {
  const { isLoading, data: externalServices = [] } = useQuery({
    queryKey: queryKeys.services.external(),
    queryFn: () => api.services.getExternal().then((r) => r.data),
  });

  return (
    <section id="external-services" className="external-services-page">
      <div className="container">
        <div className="external-services-page__container">
          <Typography variant="H1">Інші державні послуги</Typography>
          <ExternalServiceList isLoading={isLoading} list={externalServices} />
        </div>
      </div>
    </section>
  );
};
